import { fetcher } from '@commenda/utils';

type GetFileUrlResult =
  | { ok: true; data: { fileUrl: string | null } }
  | { ok: false; error: string };

const getTPDocumentFileUrl = async (
  recordId: string
): Promise<GetFileUrlResult> => {
  const res = await fetcher(`tp-document-record/${recordId}/file-url`, {
    method: 'GET',
  });

  if (!res.ok) {
    return { ok: false, error: 'Failed to get file URL' };
  }

  const data = (await res.json()) as { fileUrl: string | null };
  return { ok: true, data };
};

export { getTPDocumentFileUrl };
export type { GetFileUrlResult };
